module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/document profile icon-a0a1d044.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/document profile icon.svg
// module id = ./app/web/src/assets/document profile icon.svg
// module chunks = 0